module.exports = __webpack_public_path__ + "img/ebdfe8d.png";